import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-24e501f3-8b69-4a8d-a66e-33cb5fa42827-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "ec-6656cb83-3b22-4ae1-970b-3723cf036baa-__Layer_2_1_" }, [
      _createElementVNode("g", { id: "ec-90f51153-c4af-476b-8a3a-6bb9181fdb61-__Layer_1-2" }, [
        _createElementVNode("path", {
          id: "ec-0697f3f0-c8e4-479f-bb87-5ce9bb53c3c2-__format_bold",
          d: "m49.2 34.2c6.5-6.8 6.1-17.6-.7-24-3.1-3-7.3-4.6-11.6-4.6h-20.3c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h3.3v47h-3.3c-1.9 0-3.5 1.6-3.5 3.5s1.6 3.5 3.5 3.5h25.3c9.4 0 17-7.7 17-17-.1-6.7-3.8-12.6-9.7-15.4zm-12.3-21.7c5.5 0 10 4.5 10 10s-4.5 10-10 10h-10v-20zm5 47h-15v-20h15c5.5 0 10 4.5 10 10s-4.5 10-10 10z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }